


























import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, PainterPropertyEditableMixin, CheckerPropertyEditableMixin } from "./mixins";
import { DrawableItemEditorMixin } from "../mixins";
import FillStyleEditor from "../../../drawing/FillStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";
import MultiCheckEditor from "./MultiCheckEditor.vue";
import QuotationEditor from "./QuotationEditor.vue";

@Component({
  components: {
    fillStyleEditor: FillStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
    multiCheckEditor: MultiCheckEditor,
    quotationEditor: QuotationEditor,
  },
})
export default class CheckBoxPropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, PainterPropertyEditableMixin, CheckerPropertyEditableMixin) {
}
